import { Component, Input } from '@angular/core';
import { MAIN_MENU } from '../../data/items-main-menu.data';
import { MenuItem } from '../../models/menu-item.model';
import { SlideMenuService } from '../../services/slide-menu/slide-menu.service';

@Component({
  selector: 'app-main-header',
  templateUrl: './main-header.component.html',
  styleUrl: './main-header.component.scss'
})
export class MainHeaderComponent {

  @Input() menuData: Array<MenuItem> = [];

  public color: string = 'text-primary';

  constructor(
    public slideMenuService: SlideMenuService
  ) { }

}
